module.exports = __webpack_public_path__ + "media/images/emblems/Magden-blason-9f93643ceda4b917e576221f8b67a7c4.png";